<template>
  <div>
    <vs-card style="
        display: block;
        margin: auto;
        min-width: 350px;
        max-width: 350px;
        margin-top: 12%;
        border-radius: 10px;
      ">
      <div>
        <div class="p-2">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <a href="/login" class="logo logo-admin">
                  <img src="https://www.ausa.com.mx/img/logo-ver2.png" height="80" alt="logo"
                    style="display: block; margin: auto" />
                </a>
              </div>
              <div class="col-md-12" style="top: 30px">
                <h4 class="login-title-text" style="text-align: center">
                  Recuperar Contraseña
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="p-1">
          <form @submit.prevent="passRecoveryTry()" class="form-horizontal m-t-20" autocomplete="off">
            <div class="container mt-5">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="form-group row px-2">
                    <vs-input ref="userInput" style="width: 320px; margin: auto" :danger-text="errors.has('username') ? errors.first('username') : ''
            " name="username" data-vv-as="usuario" v-validate="'required|max:16'" type="text"
                      label-placeholder="Usuario" v-model.trim="user.username" />
                  </div>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-md-12" style="top: 30px">
                  <p class="password-recovery-title-text" style="text-align: left">
                    Si olvidaste tu contraseña ingresa tu nombre de usuario y se
                    te enviará un correo.
                  </p>
                </div>

                <div class="col-md-12" style="top: 30px">
                  <!-- <VueSimpleRecaptcha
                    :sitekey="reCaptchaSiteKey"
                    ref="recaptcha"
                    @callback="callback"
                  /> -->
                  <vue-recaptcha ref="recaptcha" :sitekey="reCaptchaSiteKey" @verify="reCaptchaSuccess"
                    @expired="reCaptchaExpired" @error="reCaptchaError" />
                </div>
              </div>
            </div>

            <div class="form-group text-center row m-t-20">
              <div class="col-6">
                <br />
                <vs-button color="#9e9e9e" type="flat" onclick="window.history.back();">
                  Regresar</vs-button>
              </div>
              <div class="col-6">
                <br />
                <button v-if="!loggedIn" class="vs-button-primary vs-button-filled btn-block vs-button" :disabled="user.username && catpchaStatus && !loggedIn ? false : true
            ">
                  <span> Recuperar </span>
                </button>
                <button v-else class="vs-button-primary vs-button-filled btn-block vs-button" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Procesando...
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div slot="footer" style="margin-top: -30px">
        <!--<vs-row vs-justify="center">
            <p style="text-align:center; margin-bottom: 50px;" class="text-muted">Login hecho para el ambiente de desarrollo local. <br/>Si usted esta viendo este login comuniquese a <b>desarrollo@ausa.com.mx</b></p>
        </vs-row>-->
        <br />
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginService from "@/services/login/login.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { VueRecaptcha } from "vue-recaptcha";
export default {
  title() {
    return this.$route.meta.title
  },
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      loggedIn: false,
      user: {
        username: "",
      },
      catpchaStatus: false,

      envioRealizado: false,
    };
  },
  computed: {
    ...mapState(["domain", "informationPage", "reCaptchaSiteKey"]),
  },
  methods: {
    onEvent() {
      // when you need a reCAPTCHA challenge
      this.$refs.recaptcha.execute();
    },

    reCaptchaSuccess() {
      this.catpchaStatus = true;
    },

    reCaptchaError() {
      this.catpchaStatus = false;
    },

    reCaptchaExpired() {
      this.catpchaStatus = false;
    },

    recuperaPassword() {
      this.$refs.recaptcha.val();
    },

    async passRecoveryTry() {
      this.loggedIn = true;
      let username = this.user.username;
      let recuperaResponse = await LoginService.recuperaPassword(username);
      if (recuperaResponse["error"] == false) {
        this.$vs.notify({
          title: "Exito!",
          text: recuperaResponse["msg"],
          color: "success",
          icon: "check_circle",
          position: "bottom-center",
          time: 12000,
        });
        this.loggedIn = false;
        this.user.username = null;
        this.$refs.recaptcha.reset();
        this.catpchaStatus = false;
      } else {
        this.$vs.notify({
          title: "Oops...",
          text: recuperaResponse["msg"],
          color: "danger",
          icon: "report",
          position: "bottom-center",
          time: 12000,
        });
        this.$refs.recaptcha.reset();

        this.catpchaStatus = false;
      }

      this.loggedIn = false;
    },
  },
  mounted() {
    //LoginService.serviceWorkerStart();
  },
};
</script>

<style scoped>
.login-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 0px;
  color: #757575 !important;
}

.password-recovery-title-text {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
  color: #9e9e9e !important;
}
</style>
